export const localeDate = (value = new Date(), locale = 'es-ES'): string => new Date(value).toLocaleDateString(locale);
